<template>
  <section class="thoughts">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-5">
          <div class="thoughts-img">
            <img src="@/assets/img/thoughts.png" alt="" />
          </div>
        </div>
        <div class="col-md-6 col-lg-7">
          <div class="thought-inner">
            <span><img src="@/assets/img/quote.svg" alt=""/></span>
            <div class="quote-text">
              Leading successful tech teams is hard. We started CTO Circle
              because we wanted to connect with and learn best practice from our
              peers. We couldn’t find an active network of CTOs, so we started
              our own.
            </div>
            <div class="author">Janakan Arulkumarsan</div>
            <div class="designation">Founder, CTO Circle</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.thoughts {
  padding: 60px 0 40px;
  background: var(--cs-gray-00);
  .thoughts-img img {
    width: 100%;
    box-shadow: 10px 20px 30px 0 rgba(0, 0, 0, 0.08);
  }

  .thought-inner {
    height: 100%;
    padding: 0 120px 0 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  @media (max-width: 768px) {
    .thought-inner {
      margin-top: 20px;
    }
  }

  .quote-text {
    margin: 18px 0 35px;
    color: #87939b;
    font-size: 20px;
    line-height: 30px;
  }

  .author {
    font-weight: bold;
    color: #47535a;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 5px;
  }

  .designation {
    color: #87939b;
    font-weight: 600;
  }
}
</style>
